var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _g2, _path11, _g3, _path12, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGenealogyView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.7392V11.2608C32 11.1168 30.3654 11 28.3489 11L7.65108 11C5.63464 11 4 11.1168 4 11.2608L4 12.7392C4 12.8832 5.63464 13 7.65108 13L28.3489 13C30.3654 13 32 12.8832 32 12.7392Z",
    fill: "url(#paint0_linear_1640_38229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7392 7H17.2608C17.1168 7 17 7.70056 17 8.56475V17.4353C17 18.2994 17.1168 19 17.2608 19H18.7392C18.8832 19 19 18.2994 19 17.4353V8.56475C19 7.70056 18.8832 7 18.7392 7Z",
    fill: "url(#paint1_linear_1640_38229)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73921 11H4.26079C4.11676 11 4 11.467 4 12.0432V17.9568C4 18.533 4.11676 19 4.26079 19H5.73921C5.88324 19 6 18.533 6 17.9568V12.0432C6 11.467 5.88324 11 5.73921 11Z",
    fill: "url(#paint2_linear_1640_38229)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7392 11H30.2608C30.1168 11 30 11.467 30 12.0432V17.9568C30 18.533 30.1168 19 30.2608 19H31.7392C31.8832 19 32 18.533 32 17.9568V12.0432C32 11.467 31.8832 11 31.7392 11Z",
    fill: "url(#paint3_linear_1640_38229)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8963 0H14.1037C13.4941 0 13 0.325615 13 0.727281V8.27272C13 8.67439 13.4941 9 14.1037 9H21.8963C22.5059 9 23 8.67439 23 8.27272V0.727281C23 0.325615 22.5059 0 21.8963 0Z",
    fill: "url(#paint4_linear_1640_38229)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8963 17H14.1037C13.4941 17 13 17.3256 13 17.7273V25.2727C13 25.6744 13.4941 26 14.1037 26H21.8963C22.5059 26 23 25.6744 23 25.2727V17.7273C23 17.3256 22.5059 17 21.8963 17Z",
    fill: "url(#paint5_linear_1640_38229)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89631 17H1.10369C0.49414 17 0 17.3256 0 17.7273V25.2727C0 25.6744 0.49414 26 1.10369 26H8.89631C9.50586 26 10 25.6744 10 25.2727V17.7273C10 17.3256 9.50586 17 8.89631 17Z",
    fill: "url(#paint6_linear_1640_38229)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8963 17H27.1037C26.4941 17 26 17.3256 26 17.7273V25.2727C26 25.6744 26.4941 26 27.1037 26H34.8963C35.5059 26 36 25.6744 36 25.2727V17.7273C36 17.3256 35.5059 17 34.8963 17Z",
    fill: "url(#paint7_linear_1640_38229)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38229",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 17,
    width: 10,
    height: 9
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8963 17H14.1037C13.4941 17 13 17.3256 13 17.7273V25.2727C13 25.6744 13.4941 26 14.1037 26H21.8963C22.5059 26 23 25.6744 23 25.2727V17.7273C23 17.3256 22.5059 17 21.8963 17Z",
    fill: "url(#paint8_linear_1640_38229)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38229)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_1640_38229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 13.2175V11.6159C32 11.4598 30.3654 11.3333 28.3489 11.3333L7.65108 11.3333C5.63464 11.3333 4 11.4598 4 11.6159L4 13.2175C4 13.3735 5.63464 13.5 7.65108 13.5L28.3489 13.5C30.3654 13.5 32 13.3735 32 13.2175Z",
    fill: "url(#paint9_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7392 7H17.2608C17.1168 7 17 7.75894 17 8.69514V18.3049C17 19.2411 17.1168 20 17.2608 20H18.7392C18.8832 20 19 19.2411 19 18.3049V8.69514C19 7.75894 18.8832 7 18.7392 7Z",
    fill: "url(#paint10_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73921 11.3333H4.26079C4.11676 11.3333 4 11.8393 4 12.4634V18.8699C4 19.494 4.11676 20 4.26079 20H5.73921C5.88324 20 6 19.494 6 18.8699V12.4634C6 11.8393 5.88324 11.3333 5.73921 11.3333Z",
    fill: "url(#paint11_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7392 11.3333H30.2608C30.1168 11.3333 30 11.8393 30 12.4634V18.8699C30 19.494 30.1168 20 30.2608 20H31.7392C31.8832 20 32 19.494 32 18.8699V12.4634C32 11.8393 31.8832 11.3333 31.7392 11.3333Z",
    fill: "url(#paint12_linear_1640_38229)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1640_38229",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 17,
    width: 10,
    height: 9
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89631 17H1.10369C0.49414 17 0 17.3256 0 17.7273V25.2727C0 25.6744 0.49414 26 1.10369 26H8.89631C9.50586 26 10 25.6744 10 25.2727V17.7273C10 17.3256 9.50586 17 8.89631 17Z",
    fill: "url(#paint13_linear_1640_38229)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1640_38229)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_f_1640_38229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 13.2175V11.6159C32 11.4598 30.3654 11.3333 28.3489 11.3333L7.65108 11.3333C5.63464 11.3333 4 11.4598 4 11.6159L4 13.2175C4 13.3735 5.63464 13.5 7.65108 13.5L28.3489 13.5C30.3654 13.5 32 13.3735 32 13.2175Z",
    fill: "url(#paint14_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7392 7H17.2608C17.1168 7 17 7.75894 17 8.69514V18.3049C17 19.2411 17.1168 20 17.2608 20H18.7392C18.8832 20 19 19.2411 19 18.3049V8.69514C19 7.75894 18.8832 7 18.7392 7Z",
    fill: "url(#paint15_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73921 11.3333H4.26079C4.11676 11.3333 4 11.8393 4 12.4634V18.8699C4 19.494 4.11676 20 4.26079 20H5.73921C5.88324 20 6 19.494 6 18.8699V12.4634C6 11.8393 5.88324 11.3333 5.73921 11.3333Z",
    fill: "url(#paint16_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7392 11.3333H30.2608C30.1168 11.3333 30 11.8393 30 12.4634V18.8699C30 19.494 30.1168 20 30.2608 20H31.7392C31.8832 20 32 19.494 32 18.8699V12.4634C32 11.8393 31.8832 11.3333 31.7392 11.3333Z",
    fill: "url(#paint17_linear_1640_38229)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1640_38229",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 17,
    width: 10,
    height: 9
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8963 17H27.1037C26.4941 17 26 17.3256 26 17.7273V25.2727C26 25.6744 26.4941 26 27.1037 26H34.8963C35.5059 26 36 25.6744 36 25.2727V17.7273C36 17.3256 35.5059 17 34.8963 17Z",
    fill: "url(#paint18_linear_1640_38229)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1640_38229)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter2_f_1640_38229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 13.2175V11.6159C32 11.4598 30.3654 11.3333 28.3489 11.3333L7.65108 11.3333C5.63464 11.3333 4 11.4598 4 11.6159L4 13.2175C4 13.3735 5.63464 13.5 7.65108 13.5L28.3489 13.5C30.3654 13.5 32 13.3735 32 13.2175Z",
    fill: "url(#paint19_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7392 7H17.2608C17.1168 7 17 7.75894 17 8.69514V18.3049C17 19.2411 17.1168 20 17.2608 20H18.7392C18.8832 20 19 19.2411 19 18.3049V8.69514C19 7.75894 18.8832 7 18.7392 7Z",
    fill: "url(#paint20_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73921 11.3333H4.26079C4.11676 11.3333 4 11.8393 4 12.4634V18.8699C4 19.494 4.11676 20 4.26079 20H5.73921C5.88324 20 6 19.494 6 18.8699V12.4634C6 11.8393 5.88324 11.3333 5.73921 11.3333Z",
    fill: "url(#paint21_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7392 11.3333H30.2608C30.1168 11.3333 30 11.8393 30 12.4634V18.8699C30 19.494 30.1168 20 30.2608 20H31.7392C31.8832 20 32 19.494 32 18.8699V12.4634C32 11.8393 31.8832 11.3333 31.7392 11.3333Z",
    fill: "url(#paint22_linear_1640_38229)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1640_38229",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 10,
    height: 9
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8963 0H14.1037C13.4941 0 13 0.325615 13 0.727281V8.27272C13 8.67439 13.4941 9 14.1037 9H21.8963C22.5059 9 23 8.67439 23 8.27272V0.727281C23 0.325615 22.5059 0 21.8963 0Z",
    fill: "url(#paint23_linear_1640_38229)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1640_38229)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter3_f_1640_38229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 12.2175V10.6159C32 10.4598 30.3654 10.3333 28.3489 10.3333L7.65108 10.3333C5.63464 10.3333 4 10.4598 4 10.6159L4 12.2175C4 12.3735 5.63464 12.5 7.65108 12.5L28.3489 12.5C30.3654 12.5 32 12.3735 32 12.2175Z",
    fill: "url(#paint24_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7392 6H17.2608C17.1168 6 17 6.75894 17 7.69514V17.3049C17 18.2411 17.1168 19 17.2608 19H18.7392C18.8832 19 19 18.2411 19 17.3049V7.69514C19 6.75894 18.8832 6 18.7392 6Z",
    fill: "url(#paint25_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73921 10.3333H4.26079C4.11676 10.3333 4 10.8393 4 11.4634V17.8699C4 18.494 4.11676 19 4.26079 19H5.73921C5.88324 19 6 18.494 6 17.8699V11.4634C6 10.8393 5.88324 10.3333 5.73921 10.3333Z",
    fill: "url(#paint26_linear_1640_38229)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7392 10.3333H30.2608C30.1168 10.3333 30 10.8393 30 11.4634V17.8699C30 18.494 30.1168 19 30.2608 19H31.7392C31.8832 19 32 18.494 32 17.8699V11.4634C32 10.8393 31.8832 10.3333 31.7392 10.3333Z",
    fill: "url(#paint27_linear_1640_38229)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1640_38229",
    x: 2,
    y: 5,
    width: 32,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1640_38229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1640_38229",
    x: 2,
    y: 5,
    width: 32,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1640_38229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1640_38229",
    x: 2,
    y: 5,
    width: 32,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1640_38229"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1640_38229",
    x: 2,
    y: 4,
    width: 32,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1640_38229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38229",
    x1: 5,
    y1: 11,
    x2: 8.28028,
    y2: 23.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38229",
    x1: 5,
    y1: 11,
    x2: 8.28028,
    y2: 23.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38229",
    x1: 5,
    y1: 11,
    x2: 8.28028,
    y2: 23.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38229",
    x1: 5,
    y1: 11,
    x2: 8.28028,
    y2: 23.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1640_38229",
    x1: 13,
    y1: 4.5,
    x2: 23,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D6FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1640_38229",
    x1: 13,
    y1: 21.5,
    x2: 23,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D6FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1640_38229",
    x1: 0,
    y1: 21.5,
    x2: 10,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D6FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1640_38229",
    x1: 26,
    y1: 21.5,
    x2: 36,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D6FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1640_38229",
    x1: 13,
    y1: 21.5,
    x2: 23,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D6FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1640_38229",
    x1: 0,
    y1: 21.5,
    x2: 10,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D6FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1640_38229",
    x1: 26,
    y1: 21.5,
    x2: 36,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D6FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1640_38229",
    x1: 5,
    y1: 11.3333,
    x2: 8.80812,
    y2: 24.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1640_38229",
    x1: 13,
    y1: 4.5,
    x2: 23,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#D6FFF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1640_38229",
    x1: 5,
    y1: 10.3333,
    x2: 8.80812,
    y2: 23.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1640_38229",
    x1: 5,
    y1: 10.3333,
    x2: 8.80812,
    y2: 23.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1640_38229",
    x1: 5,
    y1: 10.3333,
    x2: 8.80812,
    y2: 23.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1640_38229",
    x1: 5,
    y1: 10.3333,
    x2: 8.80812,
    y2: 23.8898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BDD8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGenealogyView);
export default __webpack_public_path__ + "static/media/menu-genealogy-view.ff78c4832d99697e054d4076edb8a635.svg";
export { ForwardRef as ReactComponent };